<template>
  <div class="container md:mt-24 mt-16">
    <div class="grid md:grid-cols-2 grid-cols-1 items-center mt-16 gap-[30px]">
      <div class="relative">
        <img  src="../assets/images/smartwatch/2.jpeg" class="shadow-lg border-4 border-yellow-600 w-full mx-auto" alt="">
        <div
          class="overflow-hidden absolute h-full w-72 bg-indigo-600/5 bottom-0 left-0 rotate-45 -z-1 rounded-3xl">
        </div>
      </div>

      <div class="lg:ml-8">
        <h4 class="mb-4 text-2xl leading-normal font-medium w-80">Augmentez la <b class="text-bsd-700">RENTABILITÉ</b> de votre entreprise en traitant le <b class="text-bsd-700">FEEDBACK</b> de vos clients en <b class="text-yellow uppercase">temps réels</b> </h4>
        <p class="_text-slate-400"> Grâce à notre application de feedback, les entreprises peuvent améliorer l'expérience client en prenant en compte les commentaires des clients et en y répondant de manière appropriée.Elles Gagnent   un avantage concurrentiel en offrant une expérience client exceptionnelle.</p>
        <ul class="list-none _text-slate-400 mt-4">
          <li class="mb-1 flex"><i class="uil uil-check-circle text-blue-900 text-xl mr-2"></i> Collectes</li>
          <li class="mb-1 flex"><i class="uil uil-check-circle text-bsd-700 text-xl mr-2"></i> Statistique</li>
          <li class="mb-1 flex"><i class="uil uil-check-circle text-bsd-700 text-xl mr-2"></i> Résolution</li>
          <li class="mb-1 flex"><i class="uil uil-check-circle text-bsd-700 text-xl mr-2"></i> Amélioration</li>
        </ul>

        <div class="mt-4">
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style></style>